<template>
  <div class="container py-5 py-sm-7">
    <a class="d-flex justify-content-center mb-5" href="/">
      <img class="zi-2" src="@/assets/logos/LogoCATPD.png" alt="Image Description" style="width: 24rem" />
    </a>

    <div class="mx-auto" style="max-width: 30rem">
      <div class="card card-lg mb-5">
        <div class="card-body">
          <form @submit.prevent="handleSubmit({ ...data, email: data.username })">
            <div class="text-center">
              <div class="mb-5">
                <h1 class="display-5">Authentification</h1>
              </div>
            </div>
            <!-- <span class="divider-center text-muted mb-4">via</span>
            <button class="btn btn-white btn-lg w-100 mb-3" @click.prevent="ldapLogin" type="button"
              :disabled="isLoading">
              LDAP
            </button>

            <span class="divider-center text-muted mb-4">ou</span> -->

            <div class="mb-4">
              <label class="form-label" for="email">Adresse mail</label>
              <input type="email" class="form-control form-control-lg" v-model="data.username" name="email" id="email"
                tabindex="1" placeholder="email@address.com" aria-label="email@address.com" required />
              <span class="invalid-feedback"></span>
            </div>

            <div class="mb-4">
              <label class="form-label w-100" for="password" tabindex="0">
                <span class="d-flex justify-content-between align-items-center">
                  <span>Mot de passe</span>
                </span>
              </label>

              <div class="input-group input-group-merge" data-hs-validation-validate-class>
                <input :type="showPassword ? 'text' : 'password'" class="js-toggle-password form-control form-control-lg" name="password"
                  v-model="data.password" id="password" placeholder="**********" aria-label="8+ characters required"
                  required />
                <a id="changePassTarget" class="input-group-append input-group-text"  @click="togglePassword">
                  <i id="changePassIcon" :class="showPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
                </a>
              </div>

              <span class="invalid-feedback"></span>
            </div>

            <div class="d-grid">
              <button type="submit" v-if="!isLoading" class="btn btn-primary btn-lg">
                Se connecter
              </button>
              <button type="button" disabled v-else class="btn btn-primary btn-lg">
                <div class="spinner-grow spinner-grow-sm" role="status">
                  <span class="sr-only"></span>
                </div>
                En cours ...
              </button>
            </div>
          </form>
        </div>
      </div>

      <div class="position-relative text-center zi-1">
        <small class="text-cap text-body mb-4">CPD - BENIN</small>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { mapFields } from "vuex-map-fields";

export default {
  name: "AuthLogin",
  title: "Connexion",
  data() {
    return {
      data: {
        username: null,
        password: null,
      },
      showPassword: false,
    };
  },
  computed: {
    ...mapFields("auth/login", {
      isLoading: "isLoading",
    }),
  },

  methods: {
    ...mapActions({
      handleSubmit: "auth/login/loginOscar",
      handleRedirect: "auth/login/redirectLDAP",
      reset: "auth/login/resetData",
    }),
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    async ldapLogin() {
      try {
        const data = await this.handleRedirect();
        localStorage.setItem("token", data.token);
        this.$router.push({ name: "Dashboard" });
      } catch (err) {
        console.log("err >>", err);
      }
    },
  },
};
</script>
